import React from "react"


export default function UserOption({ userOption, selected, onClick }) {
  return (
    <div
      onClick={ onClick }
      className={ `custom-multi-select-option ${ selected && "selected" }` }
    >
      { userOption.first_name } { userOption.last_name }
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/routes/qms-training/QMSTrainingManager/FunctionalGroupContainer/CreateEditFunctionalGroupModal/UserOption.js